import React, { useState } from 'react';
import './ManualCheckPanel.css';
import api from '../wrapper/API';
import ActionButton from '../input/ActionButton';
import { useSuccessBar } from '../context/SuccessBarContext';
import ProcessNotice from './ProcessNotice';
import { apiErrorMessage, formatDateTime } from './processUtils';

/** Step kind ManualCheck: a to-do that is only ticked off (POST Execute marks it done). */
function ManualCheckPanel({ process, step, active, activeActions, resetAction, onStartMode, onFinished }) {
  const { startSuccessBarLoading, startSuccessBarSuccess, closeSuccessBar } = useSuccessBar();
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleExecute = () => {
    if (saving) return;
    setSaving(true);
    setError('');
    startSuccessBarLoading('Schritt wird abgehakt');
    api.post(`/EventProcess/${process.id}/Steps/${step.stepId}/Execute`, {})
      .then(response => {
        startSuccessBarSuccess('Schritt erledigt');
        onFinished(response.data.process, response.data.warnings);
      })
      .catch(err => {
        closeSuccessBar();
        setError(apiErrorMessage(err, 'Schritt konnte nicht abgehakt werden.'));
      })
      .finally(() => setSaving(false));
  };

  if (!active) {
    const skipped = step.status === 'skipped';
    return (
      <React.Fragment>
        <p className={'processActionDesc'}>
          {skipped
            ? 'Dieser Schritt wurde übersprungen.'
            : `Abgehakt${step.executedAt ? ` am ${formatDateTime(step.executedAt)}` : ''}.`}
        </p>
        <div className={'processActionButtons'}>
          {skipped && <ActionButton icon={'task_alt'} label={'Jetzt abhaken'} type={3} onClick={() => onStartMode('run')} />}
          {resetAction}
        </div>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <p className={'processActionDesc'}>
        Manueller Schritt: Erledige „{step.label}" außerhalb des Tools und hake ihn hier ab. Es wird nichts
        automatisch ausgeführt.
      </p>
      {error && <ProcessNotice tone={'error'}>{error}</ProcessNotice>}
      <div className={'processActionButtons'}>
        <ActionButton icon={'task_alt'} label={'Als erledigt abhaken'} type={2} onClick={handleExecute} disabled={saving} />
        {activeActions}
      </div>
    </React.Fragment>
  );
}

export default ManualCheckPanel;
